import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateMealCategoryItemEntity } from '../../domain/entities/UpdateMealCategoryItemEntity'

export class UpdateMealCategoryItemModel extends UpdateMealCategoryItemEntity {
  constructor(dataDto: UpdateMealCategoryItemEntity) {
    super()
    mapEntityProperties<UpdateMealCategoryItemModel>(this, dataDto)
  }
}
